import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getNewbuildingMediaLabels } from './utils';
import { GalleryLabels } from '../../../../components/GalleryLabels';
import { useOfferContext } from '../../../../context';

export function OfferLabelsContainer() {
  const {
    hasVideo,
    hasTour,
    mediaLabels,
    isNewbuildingFromDeveloper,
    offer: { id },
  } = useOfferContext();
  const dispatch = useDispatch();

  const displayLabels = useMemo(
    () => (isNewbuildingFromDeveloper ? getNewbuildingMediaLabels({ id, dispatch }) : mediaLabels),
    [isNewbuildingFromDeveloper, mediaLabels, dispatch, id],
  );

  if (!displayLabels.length) {
    return null;
  }

  return <GalleryLabels hasFeatures={hasVideo || hasTour} labels={displayLabels} />;
}
